import React from 'react';
import { Box, Typography, Button, Chip, Stack } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const tags = ['VTuber', '3D Modeller', 'PCB Designer', 'Hacker'];

export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(180,79,255,0.18) 0%, transparent 70%), radial-gradient(ellipse 60% 40% at 80% 80%, rgba(255,110,180,0.12) 0%, transparent 60%), #0d0a12',
      }}
    >
      {/* Animated grid background */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(255,110,180,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,110,180,0.04) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
          maskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent)',
        }}
      />

      {/* Glowing orbs */}
      <Box sx={{
        position: 'absolute', width: 500, height: 500,
        borderRadius: '50%', top: '-10%', left: '-5%',
        background: 'radial-gradient(circle, rgba(180,79,255,0.12) 0%, transparent 70%)',
        filter: 'blur(40px)',
      }} />
      <Box sx={{
        position: 'absolute', width: 400, height: 400,
        borderRadius: '50%', bottom: '5%', right: '-5%',
        background: 'radial-gradient(circle, rgba(255,110,180,0.15) 0%, transparent 70%)',
        filter: 'blur(40px)',
      }} />

      <Box
        sx={{
          position: 'relative', zIndex: 1,
          textAlign: 'center', px: 3, maxWidth: 800,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: 'primary.main', letterSpacing: 6, fontSize: '0.8rem',
            mb: 2, display: 'block',
          }}
        >
          ── WELCOME TO MY CYBERSPACE ──
        </Typography>

        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '3.5rem', md: '6rem' },
            lineHeight: 1.1,
            mb: 2,
            background: 'linear-gradient(135deg, #ffffff 30%, #ff6eb4 60%, #b44fff 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: -2,
          }}
        >
          paneko<br />panko
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary', fontSize: '1.1rem',
            maxWidth: 500, mx: 'auto', mb: 4, lineHeight: 1.8,
          }}
        >
          I'm panko, a stockholm based creator, and you wanna hire me soooooo bad!!
        </Typography>

        <Stack direction="row" spacing={1} justifyContent="center" flexWrap="wrap" sx={{ mb: 5, gap: 1 }}>
          {tags.map((tag) => (
            <Chip
              key={tag}
              label={tag}
              size="small"
              sx={{
                background: 'rgba(255,110,180,0.1)',
                border: '1px solid rgba(255,110,180,0.3)',
                color: 'primary.light',
                fontWeight: 500,
              }}
            />
          ))}
        </Stack>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            onClick={() => scrollTo('#portfolio')}
            sx={{
              background: 'linear-gradient(135deg, #ff6eb4, #b44fff)',
              px: 4, py: 1.5,
              '&:hover': {
                background: 'linear-gradient(135deg, #ff9fd0, #c93d82)',
                boxShadow: '0 0 30px rgba(255,110,180,0.4)',
              },
            }}
          >
            View Portfolio
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => scrollTo('#about')}
            sx={{
              borderColor: 'rgba(255,110,180,0.4)',
              color: 'text.primary',
              px: 4, py: 1.5,
              '&:hover': {
                borderColor: 'primary.main',
                background: 'rgba(255,110,180,0.08)',
              },
            }}
          >
            About Me
          </Button>
        </Stack>
      </Box>

      <Box
        onClick={() => scrollTo('#about')}
        sx={{
          position: 'absolute', bottom: 32, left: '50%',
          transform: 'translateX(-50%)',
          cursor: 'pointer',
          animation: 'bounce 2s infinite',
          '@keyframes bounce': {
            '0%, 100%': { transform: 'translateX(-50%) translateY(0)' },
            '50%': { transform: 'translateX(-50%) translateY(10px)' },
          },
        }}
      >
        <KeyboardArrowDownIcon sx={{ color: 'primary.main', fontSize: 32 }} />
      </Box>
    </Box>
  );
}
